import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { ref, watch, onBeforeMount } from 'vue';
import EnDatePicker from 'Components/inputs/EnDatePicker';
import EnFilterButtonBase from 'Components/datagrid/filterButtons/EnFilterButtonBase.vue';
import EnFilterTypeSelectButton from 'Components/datagrid/filterButtons/EnFilterTypeSelectButton.vue';
import { dateFormatDay } from 'Js/utils/dateFormat';
import { useFilter } from '../composables/filterButtonComposable';
import { FilterType } from 'Js/enums/filterType.js';
import { FilterEvent } from '../types/filterEvent';
import { useResetFilter } from '../composables/useFilterReset';
import EnFilterButtonTypePrefix from 'Components/datagrid/filterButtons/EnFilterButtonTypePrefix.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnDateFilterButton',
    props: /*@__PURE__*/ _mergeModels({
        /**
         * The key that is used to generate the id for the input fields.
         */
        // TODO(VHA) Rename to `key`.
        id: String,
        isMonth: {
            type: Boolean,
            default: false
        },
        type: String,
        initialType: {
            type: String,
            default: FilterType.Equal,
        },
        hint: String,
        label: String,
        filterTypeSelectionVisible: Boolean,
        applyButtonText: String,
        resetButtonText: String,
        noFilterText: String,
        allowedDates: Function
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "openOnRender": {},
        "openOnRenderModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:type', 'update:modelValue', 'update:openOnRender', 'filterEvent', FilterEvent.Input, FilterEvent.FilterUpdated, FilterEvent.FilterReset], ["update:modelValue", "update:openOnRender"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const modelValue = _useModel(__props, 'modelValue');
        /**
         * A filter button for a single date value.
         */
        const componentProps = __props;
        const emit = __emit;
        const { resetFilter } = useResetFilter(emit);
        const openOnRender = _useModel(__props, 'openOnRender');
        const menuIsVisible = ref(openOnRender.value);
        const { 
        // Data
        displayString, changedValue, selectedType, 
        // Computed
        resetButtonTextComputed, applyButtonTextComputed, shouldShowPrefixComputed, 
        // Methods
        typeItemsNumber, returnTypeId, returnId, returnFilterButtonId, onResetButtonClicked, applyFilters, getDisplayString, } = useFilter(componentProps, { emit }, modelValue, updateDisplayString);
        watch(modelValue, async (value) => {
            updateDisplayString(value);
        });
        watch(() => componentProps.type, async () => {
            updateDisplayString(modelValue.value);
        });
        watch(menuIsVisible, (newValue) => {
            emit('update:openOnRender', newValue);
        });
        function updateDisplayString(value) {
            displayString.value = getDisplayString(Boolean(value) ? dateFormatDay(changedValue.value, true) : value);
        }
        onBeforeMount(() => {
            updateDisplayString(modelValue.value);
        });
        const __returned__ = { modelValue, componentProps, emit, resetFilter, openOnRender, menuIsVisible, displayString, changedValue, selectedType, resetButtonTextComputed, applyButtonTextComputed, shouldShowPrefixComputed, typeItemsNumber, returnTypeId, returnId, returnFilterButtonId, onResetButtonClicked, applyFilters, getDisplayString, updateDisplayString, get EnDatePicker() { return EnDatePicker; }, EnFilterButtonBase, EnFilterTypeSelectButton, EnFilterButtonTypePrefix };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
